export default "__VITE_ASSET__DpSdcKdm__"